export default "/assets/images/pollen-png.47a5738ebf2f3039.png";